import { TActions } from '../../../types/actions';
import { IAuctionState } from './types';
import { LOAD_PUBLISH_TERMS_SUCCESS } from '../publishTerms';
import { defaultState } from './defaultState';
import { CHANGE_AUCTION_BET, UPDATE_AUCTION } from './actions';

export function auction(state: IAuctionState = defaultState, action: TActions): IAuctionState {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS: {
      const { auction } = action.payload;
      const currentBet = state.currentBet || auction.currentBet;

      return {
        ...state,
        ...auction,
        currentBet,
      };
    }

    case CHANGE_AUCTION_BET:
      return {
        ...state,
        isBetChanged: true,
        currentBet: action.payload.bet,
      };

    case UPDATE_AUCTION:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
